import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaPreviewModalComponent } from './models/media-preview-modal/media-preview-modal.component';

@NgModule({
  declarations: [MediaPreviewModalComponent],
  imports: [CommonModule],
  exports: [
    MediaPreviewModalComponent, // Export the component to use in other modules
  ],
})
export class MediaModule {}
